import { useMemo, useState } from "react";
import { useApp } from "../app/AppContext";
import { TaskRow } from "../components/TaskRow";
import type { Task } from "../lib/api";
import { todayKey } from "../lib/date";
import { useProjects, useTaskMutations, useTasks } from "../lib/queries";
import { projectMap } from "../lib/tasks";

export function TasksPage() {
  const app = useApp();
  const tasksQ = useTasks();
  const projectsQ = useProjects();
  const { update, remove } = useTaskMutations();

  const [status, setStatus] = useState<"open" | "all" | "done">("open");
  const [search, setSearch] = useState("");

  const all = tasksQ.data ?? [];
  const projects = projectsQ.data ?? [];
  const pmap = useMemo(() => projectMap(projects), [projects]);

  const list = all
    .filter((t) => (app.filter === "all" ? true : t.projectId === app.filter))
    .filter((t) =>
      status === "open" ? t.status !== "done" : status === "done" ? t.status === "done" : true,
    )
    .filter((t) => (search.trim() ? t.title.toLowerCase().includes(search.toLowerCase()) : true))
    .sort((a, b) => (b.mit ? 1 : 0) - (a.mit ? 1 : 0) || a.pri - b.pri);

  const open = all.filter((t) => t.status !== "done").length;

  const toggle = (t: Task) =>
    update.mutate({ id: t.id, patch: { status: t.status === "done" ? "todo" : "done" } });
  // Star from the flat task list = Top-3 for the task's planned day (or today).
  const star = (t: Task) =>
    update.mutate({
      id: t.id,
      patch: t.mit
        ? { mit: false, mitDate: null }
        : { mit: true, mitDate: t.doDate ?? todayKey() },
    });
  const del = (t: Task) => remove.mutate(t.id);

  return (
    <>
      <h1 className="title">All tasks</h1>
      <p className="sub">
        {open} open · {all.length - open} done
        {app.filter !== "all" ? ` · ${projects.find((p) => p.id === app.filter)?.name ?? ""}` : ""}
      </p>

      <div className="planbar">
        <input
          className="inp"
          placeholder="Search…"
          value={search}
          onChange={(e) => setSearch(e.target.value)}
          style={{ flex: 1, minWidth: 140 }}
        />
        <select className="selc" value={status} onChange={(e) => setStatus(e.target.value as typeof status)}>
          <option value="open">Open</option>
          <option value="all">All</option>
          <option value="done">Done</option>
        </select>
        <button className="mbtn" onClick={() => app.openTask(null)}>
          + New
        </button>
      </div>

      {list.length ? (
        list.map((t) => (
          <TaskRow
            key={t.id}
            task={t}
            projects={pmap}
            onToggle={toggle}
            onStar={star}
            onDelete={del}
          />
        ))
      ) : (
        <div className="empty">No tasks match.</div>
      )}
    </>
  );
}
